import type {SyncIntegrationSpec, SyncIntegrationStruct} from '@cohort/shared/apps/sync';
import {BaseUserEventExportConfigSchema} from '@cohort/shared/apps/sync';
import {UserPropertyDataTypeSchema} from '@cohort/shared/schema/common/userProperty';
import {z} from 'zod';

export const BrevoUserPropertyColumnSchema = z.object({
  columnName: z.string(),
  referenceId: z.string(),
  propertyName: z.string(),
  dataType: UserPropertyDataTypeSchema,
});
export type BrevoUserPropertyColumn = z.infer<typeof BrevoUserPropertyColumnSchema>;

// User sync
export const BrevoUserSyncConfigSchema = z.object({
  createUsers: z.boolean(),
  userPropertyColumns: z
    .array(BrevoUserPropertyColumnSchema)
    .transform(columns => columns.filter(column => column.referenceId !== '')),
});
export type BrevoUserSyncConfig = z.infer<typeof BrevoUserSyncConfigSchema>;

export const BrevoUserSyncStateSchema = z.object({
  maxUpdatedAt: z.string().nullable(),
});
export type BrevoUserSyncState = z.infer<typeof BrevoUserSyncStateSchema>;

// User export
export const BrevoUserExportConfigSchema = z.object({
  createBrevoContacts: z.boolean(),
  userProperties: z.array(
    z.object({
      userPropertyId: z.string().uuid(),
      brevoAttributeFieldName: z.string(),
    })
  ),
});
export type BrevoUserExportConfig = z.infer<typeof BrevoUserExportConfigSchema>;

export const BrevoUserExportStateSchema = z.object({
  userAttributeLastUpdatedAt: z.string().nullable(),
  brevoContactIdAttributeLastCreatedAt: z.string().nullable(),
});
export type BrevoUserExportState = z.infer<typeof BrevoUserExportStateSchema>;

// User event export
export const BrevoUserEventExportConfigSchema = BaseUserEventExportConfigSchema.extend({});
export type BrevoUserEventExportConfig = z.infer<typeof BrevoUserEventExportConfigSchema>;

export type BrevoSyncStruct = SyncIntegrationStruct<
  BrevoUserSyncConfig,
  BrevoUserSyncState,
  never,
  BrevoUserEventExportConfig,
  BrevoUserExportConfig,
  BrevoUserExportState
>;

export const BrevoSyncSpec: SyncIntegrationSpec<BrevoSyncStruct> = {
  userSyncsConfigSchema: BrevoUserSyncConfigSchema,
  userSyncsStateSchema: BrevoUserSyncStateSchema,
  userEventExportConfigSchema: BrevoUserEventExportConfigSchema,
  contentSyncConfigSchema: null,
  userExportConfigSchema: BrevoUserExportConfigSchema,
  userExportStateSchema: BrevoUserExportStateSchema,
};
